import React from 'react';
import '../App.css';

function Navbar() {
  return (
    <div id="nav">
      <h2>logo</h2>
      <h2>menu</h2>
    </div>
  );
}

export default Navbar;
